<template>
    <div v-if="loggedIn" class="coupon-area">
        <font size="3">{{$t('app.header.coupon.code')}}</font>
        <div class="input-box">
        <b-input custom-class="input-rename" :pattern="pattern" v-model="coupon_code"></b-input>
        <button :disabled="!validation_coupon" @click="compare_coupon">{{$t('app.header.coupon.apply')}}</button>
        </div>
        <!--
        <b-button @click="show_coupon">showCoupons</b-button>
        <b-button @click="my_coupon">myCoupon</b-button>
        <b-button @click="delete_coupon">deleteCoupon</b-button>
        -->
        <div v-if="this.coupon != null && this.coupon.Active == true">
          <b-message type="is-success">
            <table class="coupon-table">
              <thead>
                  <tr>
                      <th colspan="3">{{$t('app.header.coupon.now_valid')}}</th>
                  </tr>
              </thead>
              <br>
              <tr v-if="this.coupon.RetentionDays == null">
                <td>{{$t('app.header.coupon.retention')}}</td>
                <td class="td_colon">：</td>
                <td>{{$t('app.header.coupon.indefinite')}}</td>
              </tr>
              <tr v-else>
                <td>{{$t('app.header.coupon.retention')}}</td>
                <td class="td_colon">：</td>
                <td>{{this.coupon.RetentionDays}}{{$t('app.header.coupon.days')}}</td>
              </tr>
              <tr v-if="this.coupon.expire == null">
                <td>{{$t('app.header.coupon.limit')}}</td>
                <td class="td_colon">：</td>
                <td>{{$t('app.header.coupon.indefinite')}}</td>
              </tr>
              <tr v-else>
                <td>{{$t('app.header.coupon.limit')}}</td>
                <td class="td_colon">：</td>
                <td>{{this.coupon.expire}}</td>
              </tr>
            </table>
          </b-message>
        </div>
        <div v-else-if="this.coupon != null && this.coupon.Active == false">
          <b-message type="is-warning">
            <table class="coupon-table">
              <thead>
                  <tr>
                      <th colspan="3">{{$t('app.header.coupon.expired')}}</th>
                  </tr>
              </thead>
              <br>
              <tr v-if="this.coupon.RetentionDays == null">
                <td>{{$t('app.header.coupon.retention')}}</td>
                <td class="td_colon">：</td>
                <td>{{$t('app.header.coupon.indefinite')}}</td>
              </tr>
              <tr v-else>
                <td>{{$t('app.header.coupon.retention')}}</td>
                <td class="td_colon">：</td>
                <td>{{this.coupon.RetentionDays}}{{$t('app.header.coupon.days')}}</td>
              </tr>
              <tr v-if="this.coupon.expire == null">
                <td>{{$t('app.header.coupon.limit')}}</td>
                <td class="td_colon">：</td>
                <td>{{$t('app.header.coupon.indefinite')}}</td>
              </tr>
              <tr v-else>
                <td>{{$t('app.header.coupon.limit')}}</td>
                <td class="td_colon">：</td>
                <td>{{this.coupon.expire}}</td>
              </tr>
            </table>
          </b-message>
        </div>
        <div v-else>
        <p>{{$t('app.header.coupon.nothing')}}</p>
        <br>
        </div>
        <b-modal  
            class="confirm-modal"
            :active.sync="m_active"
            has-modal-card
            :destroy-on-hide="false"
            :can-cancel="false"
        >
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{$t('app.header.coupon.confirm')}}</p>
                </header>
                <section class="modal-card-body">
                  <table class="coupon-table">
                    <thead>
                        <tr>
                            <th colspan="3">{{$t('app.header.coupon.now_valid')}}</th>
                        </tr>
                    </thead>
                    <br>
                    <tr v-if="this.coupon.RetentionDays == null">
                      <td>{{$t('app.header.coupon.retention')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{$t('app.header.coupon.indefinite')}}</td>
                    </tr>
                    <tr v-else>
                      <td>{{$t('app.header.coupon.retention')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{this.coupon.RetentionDays}}{{$t('app.header.coupon.days')}}</td>
                    </tr>
                    <tr v-if="this.coupon.expire == null">
                      <td>{{$t('app.header.coupon.limit')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{$t('app.header.coupon.indefinite')}}</td>
                    </tr>
                    <tr v-else>
                      <td>{{$t('app.header.coupon.limit')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{this.coupon.expire}}</td>
                    </tr>
                  </table>
                  <hr>
                  <table class="coupon-table" v-if="this.new_coupon != null">
                    <thead>
                        <tr>
                            <th colspan="3">{{$t('app.header.coupon.apply_coupon')}}</th>
                        </tr>
                    </thead>
                    <br>
                    <tr v-if="this.new_coupon.RetentionDays == null">
                      <td>{{$t('app.header.coupon.retention')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{$t('app.header.coupon.indefinite')}}</td>
                    </tr>
                    <tr v-else>
                      <td>{{$t('app.header.coupon.retention')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{this.new_coupon.RetentionDays}}{{$t('app.header.coupon.days')}}</td>
                    </tr>
                    <tr v-if="this.new_coupon.expire == null">
                      <td>{{$t('app.header.coupon.limit')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{$t('app.header.coupon.indefinite')}}</td>
                    </tr>
                    <tr v-else>
                      <td>{{$t('app.header.coupon.limit')}}</td>
                      <td class="td_colon">：</td>
                      <td>{{this.new_coupon.expire}}{{$t('app.header.coupon.days')}}</td>
                    </tr>
                  </table>
                    <hr>
                    <p>{{$t('app.header.coupon.confirm_m')}}</p>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="m_active = false, coupon_code = ''">Cancel</button>
                    <button class="button is-primary" @click="apply_coupon(), m_active = false">OK</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { base58_to_int } from "../../lib/base58";

export default {
  props: {
    loggedIn: {
        type: String,
        required: true
    }
  },
  data() {
    return {
      pattern: this.isFirefox? "^[A-Za-z0-9-_@\\/][A-Za-z0-9-_@ \\/]*$" : "^[0-9-_@\\/\\p{General_Category=Letter}\\p{Emoji}][0-9-_@ \\/\\p{General_Category=Letter}\\p{Emoji}]*$", // 先頭文字はSpace除く
      coupon_code: "",
      coupon: {
        Active: null,
        couponid: null,
        RetentionDays: null,
        description: null,
        name: null,
        expire: null,
        period: null
      },
      new_coupon: {
        couponid: null,
        RetentionDays: null,
        description: null,
        name: null,
        expire: null,
        period: null
      },
      m_active: false
    }
  },
  computed: {
    validation_coupon: function() {
        return RegExp(this.pattern, "u").test(this.coupon_code)
    }
  },
  mounted() {
    if (this.$store.state.coupon.coupon_now == null) {
        this.my_coupon()
    }else {
        this.coupon = this.$store.state.coupon.coupon_now
    }
  },
  methods: {
    /*
    show_coupon(){
      this.showCoupons()
      .then(
        (res) => {
          console.log(res)
        }
      )
    },
    */
    my_coupon(){
      if (this.$store.state.account.id != null && this.$store.state.account.refreshToken != null) {
        this.getCoupon()
        .then(
          (res) => {
            if (res.OwnCoupons.length != 0) {
              let c = res.OwnCoupons[res.OwnCoupons.length - 1]
              if (c.expire == null){
                c.expire = null
              }else {
                c.expire = String(c.expire).split('T')[0]
                c.expire = c.expire.replace(/-/g, '/')
              }

              if (c.Period == null) {
                c.Period = "未定"
              }else {
                c.Period = String(c.Period).split('T')[0]
                c.Period = c.Period.replace(/-/g, '/')
              }

              this.coupon = {
                Active: c.Active,
                couponid: c.couponid,
                RetentionDays: c.RetentionDays,
                description: c.description,
                name: c.name,
                expire: c.expire,
                Period: c.Period
              }
              this.updateStoreCoupon(this.coupon)
            }
          }
        )
      }
    },
    compare_coupon(){
      const code58 = String(base58_to_int(this.coupon_code))
      let id = parseInt(code58.slice(0, 3))
      this.showCoupon(id)
      .then(
        (res) => {
          if (res.Coupon.CampaignIsOver == true) {
            throw new Error("終了したクーポン")
          }else {
            if (res.Coupon.CampaignPeriod == null) {
              res.Coupon.CampaignPeriod = null
            }else {
              res.Coupon.CampaignPeriod = String(res.Coupon.CampaignPeriod).split('T')[0]
              res.Coupon.CampaignPeriod = res.Coupon.CampaignPeriod.replace(/-/g, '/')
            }

            this.new_coupon = {
              Active: res.Coupon.Active,
              couponid: res.Coupon.couponid,
              RetentionDays: res.Coupon.RetentionDays,
              description: res.Coupon.description,
              name: res.Coupon.name,
              expire: res.Coupon.ExpireDays,
              period: res.Coupon.CampaignPeriod
            }

            if (this.coupon.Active == true) {
                this.m_active = true
            }else {
                this.apply_coupon()
            }
          }
        }
      )
      .catch(
        (e) => {
          if (e.message == "終了したクーポン") {
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.header.coupon.expired_warning'),
              position: "is-top",
              type: "is-danger"
            })
          }else {
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.dashboard.graph.error_warning'),
              position: "is-top",
              type: "is-danger"
            })
          }
          this.coupon_code = ""
        }
      )
    },
    apply_coupon() {
      this.registerCoupon({code: this.coupon_code, force: "true"})
      .then(
        () => { 
          //console.log("新規クーポンが正常に登録されました!")
            this.$buefy.toast.open({
                duration: 2000,
                message: this.$t("app.header.coupon.success"),
                position: "is-top",
                type: "is-success"
            })
        }
      )
      .catch(
        (e) => {
          if (e.message == '"You have a coupon already."\n') {
            //console.error("このクーポンは既に持っています")
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.header.coupon.already_own'),
              position: "is-top",
              type: "is-danger"
            })
          }else if(e.message === '"This coupon already being used."\n') {
            //console.error("このクーポンは既に使用されています")
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.header.coupon.already_applyed'),
              position: "is-top",
              type: "is-danger"
            })
          }else {
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.dashboard.graph.error_warning'),
              position: "is-top",
              type: "is-danger"
            })
          }
        }
      )
      .finally(
        () => {
          this.coupon_code = ""
          this.my_coupon()
        }
      )
    },
    delete_coupon(){
      this.deleteCoupon()
      .catch(
        () => {
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.dashboard.graph.error_warning'),
              position: "is-top",
              type: "is-danger"
            })
        }
      )
    },
    ...mapActions({
      updateStoreCoupon: 'coupon/updateStoreCoupon',
      showCoupon: 'coupon/showCoupon',
      showCoupons: 'coupon/showCoupons',
      getCoupon: 'coupon/getCoupon',
      registerCoupon: 'coupon/registerCoupon',
      deleteCoupon: 'coupon/deleteCoupon'
    })
  },
}
</script>

<style scoped>
.input-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.input-box div {
  /*width: 90%;*/
  width: calc(100% - 5px);
  height: 40px;
  padding: 0 0px;
  font-size: 0.9375rem;
  border: 0px solid #ccc;
  border-radius: 4px;
}
.input-box button {
  width: 100px;
  height: 40px;
  padding: 0 10px;
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9375rem;
  cursor: pointer;
}
.input-box button i {
  margin-right: .3em;
}
.input-box button:hover {
  opacity: .7;
}
.coupon-area {
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
}
.coupon-table {
  border-collapse: separate;
  border-spacing: 0px 8px;
}
.coupon-table tr td {
  text-align: center;
  width: 50%;
}
.td_colon {
  width: 2px !important;
}
</style>
